/**
 * Products
 */

import { isOnPage, loadPost } from './utils';

const state = {
  cart: {
    count: 0,
  },
};

const cartCounter = document.querySelector('#cart-count');

const showLoader = (btn) => {
  btn.classList.add('btn--disabled');
  btn.querySelector('.ajax-loader').classList.add('ajax-loader--visible');
};

const hideLoader = (btn) => {
  btn.classList.remove('btn--disabled');
  btn.querySelector('.ajax-loader').classList.remove('ajax-loader--visible');
};

const updateCartCounter = (cartState) => {
  if (cartState.count === 0) {
    cartCounter.textContent = 0;
    cartCounter.classList.add('hidden');
  } else {
    cartCounter.textContent = cartState.count;
    cartCounter.classList.remove('hidden');
    cartCounter.parentElement.classList.add('animate');
  }
};

const addToCart = (btn) => {
  const productId = parseInt(btn.getAttribute('data-product_id'), 10);
  const months = btn.dataset.months.split(',');

  const productData = {
    product_id: productId,
    quantity: 1,
    cart_item_data: {
      months,
    },
    return_item: true,
    return_cart: true,
  };

  $.ajax({
    method: 'POST',
    url: `${window.location.origin}/wp-json/cocart/v1/add-item`,
    data: productData,
    beforeSend() {
      showLoader(btn);
      cartCounter.parentElement.classList.remove('animate');
    },
    success(data) {
      const cartItems = Object.values(data.items).filter((item) => item.product_id === productId);
      btn.setAttribute('data-cart-key', cartItems[0].key);
      btn.setAttribute('title', 'Убрать из корзины');
      btn.classList.add('btn--cart-checked');
      state.cart.count = data.item_count;
      updateCartCounter(state.cart);
    },
    error(error) {
      console.error(error);
    },
    complete() {
      hideLoader(btn);
    },
  });
};

const removeFromCart = (btn) => {
  const isCartPage = isOnPage('#cart');
  const cartCount = document.querySelector('#cart-count');
  const cartCountValue = parseInt(cartCount.textContent, 10);

  $.ajax({
    method: 'DELETE',
    url: `${window.location.origin}/wp-json/cocart/v1/item`,
    data: {
      cart_item_key: btn.getAttribute('data-cart-key'),
      return_cart: true,
    },
    beforeSend() {
      showLoader(btn);
    },
    success() {
      if (isCartPage) {
        btn.closest('tr').style.display = 'none';
        document.querySelector('.products__count-count').textContent = (cartCountValue > 0) ? cartCountValue - 1 : 0;
      }
      btn.classList.remove('btn--cart-checked');
      btn.setAttribute('title', 'Добавить в корзину');
      cartCount.textContent = (cartCountValue > 0) ? cartCountValue - 1 : 0;
      state.cart.count = cartCountValue - 1;
      updateCartCounter(state.cart);
    },
    error(data) {
      console.log(data);
    },
    complete() {
      hideLoader(btn);
    },
  });
};

if (isOnPage('.btn--cart')) {
  Array.from(document.querySelectorAll('.btn--cart')).forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      if (btn.classList.contains('btn--cart-checked')) {
        removeFromCart(btn);
      } else {
        addToCart(btn);
      }
    });
  });
}

if (isOnPage('.btn--remove')) {
  Array.from(document.querySelectorAll('.btn--remove')).forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      removeFromCart(btn);
    });
  });
}

if (isOnPage('.products__item-link')) {
  const productEndpoint = `${window.location.origin}/wp-json/motion/v1/product_type/`;

  Array.from(document.querySelectorAll('.products__item-link')).forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      loadPost(btn, productEndpoint);
    });
  });
}

/**
 * Bulk add to cart.
 */
const initBulkAddToCart = () => {
  state.products = [];

  const bulkAddToCartBtn = document.querySelector('#bulk-add-to-cart-btn');
  const products = Array.from(document.querySelectorAll('.search__table > tbody > tr'));

  const updateProducts = (items) => {
    const addedItems = items
      .filter((item) => item.status === 'success')
      .map((item) => item.id);

    state.products.forEach((product) => {
      if (addedItems.includes(product.id)) {
        const btn = product.el.querySelector('.search__table-cart');
        const [cartItemKey] = items.filter((item) => item.id === product.id);
        btn.setAttribute('data-cart-key', cartItemKey.key);
        btn.setAttribute('title', 'Убрать из корзины');
        btn.classList.add('btn--cart-checked');
      }
    });
  };

  products.forEach((product) => {
    const btn = product.querySelector('.search__table-cart');

    if (btn) {
      const productId = parseInt(btn.dataset.product_id, 10);
      const months = btn.dataset.months.split(',');

      state.products.push({
        id: productId,
        el: product,
        months,
        status: 'pending',
      });
    }
  });

  bulkAddToCartBtn.addEventListener('click', () => {
    const productsData = state.products.map((product) => {
      const { id, months } = product;

      return { id, months };
    });

    $.ajax({
      method: 'POST',
      url: `${window.location.origin}/wp-json/motion/v1/bulk_add_to_cart`,
      data: {
        items: productsData,
      },
      beforeSend() {
        products.forEach((product) => {
          showLoader(product.querySelector('.search__table-cart'));
        });
      },
      success(data) {
        updateProducts(data.items);
        state.cart.count = data.cart_count;
        updateCartCounter(state.cart);
      },
      error(data) {
        console.log(data);
      },
      complete() {
        products.forEach((product) => {
          hideLoader(product.querySelector('.search__table-cart'));
        });
      },
    });
  });
};

if (isOnPage('#bulk-add-to-cart-btn')) {
  initBulkAddToCart();
}

export { addToCart };
export default addToCart;
